
import { Injectable, Inject } from '@angular/core';
import { Observable, config } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpWrapper } from '../../http/HttpWrapper';
import { APP_CONFIG, IAppConfig } from '../../app.config';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MetadataLayerService {

  constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) { }

  enpoint:string = this.config.endpointLayers;
  
  callBackend(appcontext:string){
    let uri = this.enpoint + '?appcontext=' + appcontext
    //return this.httpWrapper._request(RequestMethod.Get, this.enpoint + '?appcontext=' + appcontext, null, null, ResponseContentType.Json, false)
    return this.http.get(uri, { observe: 'response', responseType: 'json' })
    .pipe(map((res:any)  => res),
    catchError((error:any) => Observable.throw(error || 'Server error')));
  }

  //Assegna ad ogni operation il relativo layer
  parseLayers(jsonFile: any[], appcontext:string){

    jsonFile = jsonFile.find(element=> element.appcontext == appcontext)
   
    return jsonFile;
  }


}
